import React, { useState } from "react";
import { T, MOTIVOS } from "../../lib/cfdi";

// Formulario de cancelación de una factura ante el SAT (CL.4 C). Lo comparten el modal del cobro
// (FacturarCobro) y el historial de facturas (CL.4 C3): un solo flujo, un solo sitio. La llamada
// la hace quien lo usa (`onConfirmar(motivo)`); aquí sólo se elige el motivo.
// Textos: lib/cfdi.js (# Copy aprobado por Jesús (4 Oct 2026)).
const btn = "px-3 py-1.5 text-xs rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1.5 disabled:opacity-60";

export default function CancelarCfdi({ ocupado, onVolver, onConfirmar }) {
  const [motivo, setMotivo] = useState("02");
  return (
    <div className="space-y-3" data-testid="cfdi-cancelar-form">
      <p className="text-sm font-medium text-slate-900">{T.cancelarTitulo}</p>
      <p className="text-xs text-red-600">{T.cancelarAviso}</p>
      <label className="block text-xs font-medium text-slate-600">{T.motivo}
        <select className="mt-1 h-9 w-full rounded-lg border border-slate-200 px-2 text-sm" value={motivo}
                onChange={(e) => setMotivo(e.target.value)} data-testid="cfdi-motivo">
          {MOTIVOS.map((m) => <option key={m.code} value={m.code}>{m.label}</option>)}
        </select>
      </label>
      <div className="flex gap-2">
        <button type="button" className={btn} onClick={onVolver}>{T.volver}</button>
        <button type="button" disabled={ocupado} data-testid="cfdi-confirmar-cancelacion"
                className="px-3 py-1.5 text-xs rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
                onClick={() => onConfirmar(motivo)}>
          {T.confirmarCancelacion}
        </button>
      </div>
    </div>
  );
}
